// All or portions of this file Copyright © 2019 Amazon Web Services, Inc. or its affiliates or licensors.
// All rights reserved. For full license terms and conditions, please see the LICENSE file at the root of
// this distribution (the "License") or go to https://content.sumerian.amazonaws.com/engine/latest/license.txt.
// All use of the software is governed by the License. All materials are made available on an "AS IS" BASIS, WITHOUT
// WARRANTIES OR CONDITIONS OF ANY KIND, express or implied. Do not remove or modify any license notices.
import AutoPassiveSystemMixin from '../../entities/systems/AutoPassiveSystemMixin';
import AutoStateSystemMixin from '../../entities/systems/AutoStateSystemMixin';
import System from '../../entities/systems/System';
import World from '../../entities/World';

/**
 * Processes all entities with animation components, updating the animations
 */
class AnimationSystem extends AutoStateSystemMixin(
  AutoPassiveSystemMixin(System)
) {
  constructor() {
    super('AnimationSystem', ['AnimationComponent']);
  }

  process() {
    for (const entity of this._activeEntities) {
      const animationComponent = entity.animationComponent;
      animationComponent.update(entity.world.time);
      animationComponent.apply(entity.transformComponent);
      animationComponent.postUpdate();
    }
  }
  
  _startEntity(entity) {
    // nothing to do
  }
  
  _pauseEntity(entity) {
    entity.animationComponent.pause();
  }
  
  _resumeEntity(entity) {
    entity.animationComponent.resume();
  }
  
  _stopEntity(entity) {
    entity.animationComponent.stop();
  }
  
}

export default AnimationSystem;
